import React, {Component} from 'react'

import HeaderSearchMobileComponent from './HeaderSearchMobile.component'

class HeaderSearchContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      search: props.search
    }
  }

    handleCloseClick = (evt) => {
      evt.preventDefault()

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Close Header Search Mobile',
        type: 'Datatable'
      })

      this.props.onClose()
    }

    handleSearchInputChange = (evt) => {
      this.setState({
        search: evt.target.value
      })
    }

    handleApplySearch = (evt) => {
      evt.preventDefault()

      this.props.handleSearch(this.state.search)

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Apply Header Mobile Search',
        type: 'Datatable'
      })

      this.props.onClose()
    }

    render() {
      const events = {
        handleCloseClick: this.handleCloseClick,
        handleChange: this.handleSearchInputChange,
        handleApply: this.handleApplySearch
      }

      const {search} = this.state
      const {i18n} = this.props

      return (
        <HeaderSearchMobileComponent
          events={events}
          search={search}
          i18n={i18n}
        />
      )
    }
}

export default HeaderSearchContainer
